import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import api from "../../services/api";
import Template from "../../template";
import { toast } from "react-toastify";
import ChatDanizinha from "../../components/ChatDanizinha";
import DanizinhaImg from "../../assets/img/Danizinha_img.png";

import CorrecaoResultadoUI from "../../components/CorrecaoResultadoUI";
import * as S from "./styled";

function CorrecaoIA(props) {
  const { id } = props.match.params;
  const history = useHistory();

  const [correcaoData, setCorrecaoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showChat, setShowChat] = useState(true);
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    async function getCorrecaoIA() {
      try {
        const response = await api.post("/getCorrecao/ia", {
          id_redacao: parseInt(id, 10),
        });
        setCorrecaoData(response.data);
      } catch (error) {
        console.error("Erro ao buscar correção:", error);

        if (error?.response?.status === 404) {
          toast.error("Correção não encontrada. Pode ser que ainda esteja sendo processada.");
        } else {
          toast.error("Erro ao carregar correção da IA");
        }
      } finally {
        setLoading(false);
      }
    }

    getCorrecaoIA();
  }, [id]);

  if (loading) {
    return (
      <Template>
        <Container>
          <Row>
            <Col className="text-center mt-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Carregando...</span>
              </div>
              <p className="mt-3">Carregando correção...</p>
            </Col>
          </Row>
        </Container>
      </Template>
    );
  }

  if (!correcaoData) {
    return (
      <Template>
        <Container>
          <Row>
            <Col className="text-center mt-5">
              <h3>Correção não encontrada</h3>
              <button className="btn btn-primary mt-3" onClick={() => history.goBack()}>
                Voltar
              </button>
            </Col>
          </Row>
        </Container>
      </Template>
    );
  }

  const competencias = {
    c1: correcaoData.c1_nota,
    c2: correcaoData.c2_nota,
    c3: correcaoData.c3_nota,
    c4: correcaoData.c4_nota,
    c5: correcaoData.c5_nota,
  };

  const comentarios = {
    c1: correcaoData.c1_text,
    c2: correcaoData.c2_text,
    c3: correcaoData.c3_text,
    c4: correcaoData.c4_text,
    c5: correcaoData.c5_text,
  };

  const imageUrl = correcaoData.url_redacao
    ? `https://redacoes.nyc3.digitaloceanspaces.com/${correcaoData.url_redacao}`
    : null;

  return (
    <Template>
      <CorrecaoResultadoUI
        title="Correção da Redação - Inteligência Artificial"
        notaFinal={correcaoData.nota_final}
        competencias={competencias}
        comentarios={comentarios}
        imageUrl={imageUrl}
        onBack={() => history.goBack()}
        extraActions={
          <button
            className="btn btn-outline-primary"
            onClick={() => history.push("/minhas-redacoes?tipo=ia")}
          >
            Ir para Minhas redações
          </button>
        }
      />

      {/* Notificação animada */}
      {showNotification && !showChat && (
        <S.ChatNotification>
          Dúvidas? Converse comigo!
          <S.NotificationClose onClick={() => setShowNotification(false)}>
            ×
          </S.NotificationClose>
        </S.ChatNotification>
      )}

      {/* Botão flutuante para toggle do chat */}
      {!showChat && (
        <S.FloatingButton
          onClick={() => {
            setShowChat(true);
            setShowNotification(false);
          }}
        >
          <S.FloatingButtonImage src={DanizinhaImg} alt="Danizinha" />
        </S.FloatingButton>
      )}

      {/* Chat da Danizinha */}
      <ChatDanizinha
        show={showChat}
        onHide={() => setShowChat(false)}
        redacaoId={id}
        correcaoData={correcaoData}
        onInitialize={() => {}}
      />
    </Template>
  );
}

export default CorrecaoIA;